function lazyLoadDOMChanged() {
	window.lazyLoads = [].slice.call(document.querySelectorAll('[data-view-style], [data-view-class], [data-view-src], [data-view-bg-url], [data-view-bg-url-mobile], [data-view-bg-url-desktop], [data-view-run]'));
}

document.addEventListener('DOMContentLoaded', _ => {
	window.setTimeout(_ => {
		lazyLoadDOMChanged();
		let timer = setInterval(x => {
			if (window.lazyLoads.length) {
				for (var i = 0; i < window.lazyLoads.length; ++i) {
					let el = window.lazyLoads[i];
					if (isInViewport(el)) {
						if (el.hasAttribute('data-view-style')) {
							el.setAttribute('style', el.getAttribute('data-view-style'));
							el.removeAttribute('data-view-style');
						} else if (el.hasAttribute('data-view-class')) {
							el.classList.add(el.dataset.viewClass);
							el.removeAttribute('data-view-class');
						} else if (el.hasAttribute('data-view-src')) {
							el.src = el.dataset.viewSrc;
							el.removeAttribute('data-view-src');
						} else if (el.hasAttribute('data-view-run')) {
							let runnable = el.dataset.viewRun;
							el.removeAttribute('data-view-run');
							eval(runnable);
						} else {
							var width = window.innerWidth
								|| document.documentElement.clientWidth
								|| document.body.clientWidth;

							let url = '';
							if ((width > 480) && el.hasAttribute('data-view-bg-url-desktop')) {
								url = el.dataset.viewBgUrlDesktop;
								el.removeAttribute('data-view-bg-url-desktop');
							} else if ((width <= 480) && el.hasAttribute('data-view-bg-url-mobile')) {
								url = el.dataset.viewBgUrlMobile;
								el.removeAttribute('data-view-bg-url-mobile');
							} else {
								url = el.dataset.viewBgUrl;
								el.removeAttribute('data-view-bg-url');
							}

							el.style.display = 'none';
							if (el.parentElement) {
								let parentStyle = el.parentElement.style;
								parentStyle.background = 'center no-repeat url(' + url + ')';
								parentStyle.background.size = 'cover';
								parentStyle.width = '100%';
								parentStyle.height = '100%';
							}
						}

						window.lazyLoads.splice(i, 1);
						i--;
					}
				}
			}
		}, 333);
	}, 100);
});
